import React, { useEffect, useState } from 'react'
import { classNames } from 'src/lib/utils/helpers'

interface LogoWithFallbackProps {
  logoUrl?: string
  fallbackText: string
  id?: string
  expanded?: boolean
  onTypeChange?: (type: 'image' | 'text') => void
}

const LogoWithFallback: React.FC<LogoWithFallbackProps> = ({
  logoUrl,
  fallbackText,
  id,
  expanded = true,
  onTypeChange
}) => {
  const [imageError, setImageError] = useState(false)

  useEffect(() => {
    onTypeChange?.(logoUrl && !imageError ? 'image' : 'text')
  }, [logoUrl, imageError, onTypeChange])

  const containerClass = classNames(
    'flex items-center justify-center rounded-md flex-none overflow-hidden',
    expanded ? 'w-fit max-w-12 h-6' : 'w-fit min-w-9 max-w-12 h-6'
  )

  if (logoUrl && !imageError) {
    return (
      <div className={containerClass} id={id}>
        <img src={logoUrl} alt='logo' className='w-full h-full object-contain' onError={() => setImageError(true)} />
      </div>
    )
  }

  return (
    <div
      className='w-6 h-6 text-xs font-semibold rounded-md bg-teal-600/10 flex items-center justify-center text-teal-600'
      id={id}
    >
      {fallbackText}
    </div>
  )
}

export default LogoWithFallback
